export default __webpack_public_path__ + "static/media/logo-text.911ca987.png";